/*
 * Copyright (c) 2021. Manchester Economic Forecasting Limited <http://mef-uk.com>
 */

import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './config/theme';
import App from './App';
import * as registerServiceWorker from './registerServiceWorker';

registerServiceWorker.register();

const rootElement = document.getElementById('root');
ReactDOM.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<App />
		</ThemeProvider>
	</React.StrictMode>,
	rootElement
);
